import React from 'react';

import PropTypes from '../../propTypes';
import { FirstName, LastName } from '../forms/Fields';
import { NAME_TITLE, NAME_DESCRIPTION } from '../../messages';
import { TranslatedMessage } from 'common/components/Intl';

const SimpleFormNameFieldGroup = ({ showHeading, disabled }) => (
  <div className="NameFieldGroup">
    <div className="AddressForm__group">
      {showHeading && (
        <div>
          <div className="AddressForm__group-title">
            <TranslatedMessage id={NAME_TITLE} />
          </div>
          <p className="AddressForm__group-description">
            <TranslatedMessage id={NAME_DESCRIPTION} />
          </p>
        </div>
      )}

      <div className="NameFieldGroup__fields">
        <FirstName disabled={disabled} />
        <LastName disabled={disabled} />
      </div>
    </div>
  </div>
);

SimpleFormNameFieldGroup.propTypes = {
  showHeading: PropTypes.bool,
  disabled: PropTypes.bool,
};

SimpleFormNameFieldGroup.defaultProps = {
  showHeading: true,
  disabled: false,
};

export default SimpleFormNameFieldGroup;
